export enum EnumQrBatchStatus {
  READY_TO_DOWNLOAD = 'Siap Diunduh',
  ON_PROGRESS = 'Diproses',
  IS_DOWNLOAD = 'Telah Diunduh',
}
